const IMAGES_PATH = '/assets/images';
export const avatar = `${IMAGES_PATH}/avatar.jfif`;